<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="panel panel-primary">
        <div class="panel-heading custom-panel">
          <div class="titulo-painel">
            <h2>{{ tituloDaEtapaAtual }}</h2>
          </div>
        </div>
      </div>

      <div>
        <div>
          <mat-divider fxFlex="1 0"></mat-divider>
        </div>
        <div
          *ngIf="usuarioLogado.username"
          class="text-danger"
          style="margin-top: 5px; margin-bottom: 5px"
        >
          Atendente Logado: {{ usuarioLogado.username }}
        </div>

        <div>
          <div class="form-group">
            <mat-divider fxFlex="1 0"></mat-divider>
          </div>
          <div class="panel-heading custom-sub-panel">
            <div class="titulo-sub-painel">
              <h3>Seleção do Exame</h3>
            </div>
          </div>

          <div class="form-container">
            <div class="form-column-2">
              <!-- <div class="filter-bar">
                <div>
                  <div class="filter-item">
                    <label>Tipo de Exame</label>
                    <select
                      [ngModel]="filtroProcedimentoId"
                      (ngModelChange)="
                        filtroProcedimentoId = $event; applyFilters()
                      "
                    >
                      <option [ngValue]="null">Todos</option>
                      <option
                        *ngFor="let p of procedimentosSelecionados"
                        [ngValue]="p.id"
                      >
                        {{ p.nome }}
                      </option>
                    </select>
                  </div>

                  <div class="filter-item">
                    <label>Local (Filial)</label>
                    <select
                      [ngModel]="filtroFilialId"
                      (ngModelChange)="filtroFilialId = $event; applyFilters()"
                    >
                      <option [ngValue]="null">Todos</option>
                      <option
                        *ngFor="let f of filiaisDisponiveis"
                        [ngValue]="f.id"
                      >
                        {{ f.nome }}
                      </option>
                    </select>
                  </div>
                </div>

              
                <div class="filter-item">
                  <label>Data Início</label>
                  <input
                    type="date"
                    [(ngModel)]="filtroDataInicio"
                    (ngModelChange)="onDataInicioChange($event)"
                  />
                </div>

               
                <div class="filter-item">
                  <label>Data Fim</label>
                  <input
                    type="date"
                    [(ngModel)]="filtroDataFim"
                    [disabled]="!filtroDataInicio"
                    [min]="filtroDataInicio"
                    (ngModelChange)="onDataFimChange($event)"
                  />
                </div>

       
                <div class="filter-actions">
                  <button
                    mat-raised-button
                    color="primary"
                    type="button"
                    matTooltip="Limpar Filtros"
                    (click)="resetFilters()"
                  >
                    Limpar
                  </button>
                </div>
              </div> -->
              <div class="agenda-container">
                <div class="agenda-body">
                  <div
                    *ngIf="procedimentosSelecionados.length === 0"
                    class="agenda-mensagem"
                  >
                    <strong
                      >Selecione ao menos um procedimento para visualizar a
                      agenda.</strong
                    >
                  </div>

                  <!-- 🔴 Nenhuma agenda encontrada -->
                  <div
                    *ngIf="
                      procedimentosSelecionados.length != 0 &&
                      nenhumAgendamentoEncontrado
                    "
                    class="agenda-mensagem"
                  >
                    <strong>Nenhuma agenda encontrada. </strong>
                  </div>

                  <!-- 🟢 Agenda -->
                  <ng-container
                    *ngIf="
                      procedimentosSelecionados.length > 0 &&
                      possiveisMarcacoesRemapeadas.length > 0
                    "
                  >
                    <!-- DIA -->
                    <div
                      *ngFor="let dia of possiveisMarcacoesRemapeadas"
                      class="agenda-dia"
                    >
                      <!-- LOCAL -->
                      <div
                        *ngFor="let local of dia.locais"
                        class="agenda-local"
                      >
                        <div class="agenda-header">
                          {{ dia.data | date: "dd/MM/yyyy" }} -
                          {{ local.nomeFilial }}
                        </div>

                        <!-- HORÁRIOS -->
                        <ng-container
                          *ngFor="let h of local.horarios; let isLast = last"
                        >
                          <div
                            class="agenda-horario"
                            [ngClass]="{
                              selecionado: isPossivelMarcacaoSelecionada(
                                h.marcacao
                              )
                            }"
                            (click)="onTogglePossivelMarcacao(h.marcacao)"
                          >
                            <mat-checkbox
                              [checked]="
                                isPossivelMarcacaoSelecionada(h.marcacao)
                              "
                              (click)="$event.preventDefault()"
                              color="primary"
                              style="margin-top: 6px"
                            >
                            </mat-checkbox>

                            <span class="hora">
                              {{ h.hora }}
                            </span>

                            <span class="descricao">
                              {{ h.marcacao.procedimento.nome }}
                              <ng-container *ngIf="h.mostrarMedico">
                                | {{ h.marcacao.nomeMedico }}
                              </ng-container>
                            </span>
                          </div>

                          <!-- LINHA SÓ SE NÃO FOR O ÚLTIMO -->
                          <div *ngIf="!isLast" class="linha-separadora"></div>
                        </ng-container>
                      </div></div
                  ></ng-container>
                </div>

                <div class="agenda-footer">
                  <div colspan="6">
                    <strong>
                      Procedimentos na lista:
                      {{ possiveisMarcacoesFiltradas.length }}
                    </strong>
                  </div>
                  <div colspan="6">
                    <strong>
                      Procedimentos selecionados:
                      {{ possiveisMarcacoesSelecionadas.length }}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- TABELA DE ITENS SELECIONADOS -->
            <!-- <div
              *ngIf="possiveisMarcacoesSelecionadas.length > 0"
              class="selected-container"
              style="margin-top: 1rem"
            >
              <h3>Exames Selecionados</h3>
              <div class="table-container">
                <table class="table table-bordered table-striped table-proce">
                  <thead>
                    <tr>
                      <th>Local</th>
                      <th>Procedimento</th>
                      <th>Médico</th>
                      <th class="col-data-hora">Data / Hora</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let sel of possiveisMarcacoesSelecionadas;
                        let i = index
                      "
                    >
                      <td>{{ sel.filial.nome }}</td>
                      <td>{{ sel.procedimento.nome }}</td>
                      <td>{{ sel.nomeMedico }}</td>
                      <td>
                        {{ sel.melhorData | date : "dd/MM/yyyy" }}<br />
                        {{ sel.melhorHoraFormatada }}
                      </td>
                      <td>
                        <button
                          mat-button
                          color="warn"
                          (click)="removerPossivelMarcacao(i)"
                        >
                          Remover
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5">
                        <strong
                          >Total selecionados:
                          {{ possiveisMarcacoesSelecionadas.length }}</strong
                        >
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div> -->
          </div>

          <div class="form-row" style="margin-left: 10px; margin-right: 10px">
            <div
              class="form-group botao-marcacao-esquerda col-12 col-sm-6 col-md-6 col-lg-6"
            >
              <button
                type="button"
                (click)="telaAnterior()"
                mat-raised-button
                color="warn"
                matTooltip="Tela Anterior"
                style="margin-bottom: 10px"
                class="mat-button-marcacao"
              >
                <mat-icon>arrow_left</mat-icon>
                Tela Anterior
              </button>
            </div>
            <div
              class="form-group botao-marcacao-direita col-12 col-sm-6 col-md-6 col-lg-6"
            >
              <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="onSubmit()"
                matTooltip="Continuar Marcação"
                class="mat-button-marcacao"
              >
                Finalizar Marcação
                <mat-icon>arrow_right</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
